import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setTextEmployerFilter } from '../../redux/slices/employer.slice';
// import { DatePicker } from 'antd'

// const dateFormat = 'DD-MM-YYYY';

function ContractorFilter() {
  const [text, setText] = useState('');
  const dispatch = useDispatch();
  return (
    <div className="flex flex-col w-full h-fit p-4 rounded-md shadow-[0_0_5px_#C4C4C4] mb-4">
      <div className="mb-6">
        <p className="text-xl font-medium">Фильтр</p>
      </div>

      <div className="mb-3">
        <input
          onChange={(e) => {
            setText(e.target.value);
          }}
          value={text}
          type="text"
          name="name"
          id="name"
          className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-blue-500 focus:outline-none sm:text-sm sm:leading-6"
          placeholder="Название"
          required
        />
      </div>

      <div className="mb-3 px-2 flex flex-col gap-y-2">
        <button
          type="button"
          onClick={() => {
            dispatch(setTextEmployerFilter(text));
          }}
          className="text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov mr-2 w-full transition ease-in-out duration-300">
          Применить
        </button>
        <button
          onClick={() => {
            setText('');
            dispatch(setTextEmployerFilter(''));
          }}
          type="button"
          className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
          Сбросить
        </button>
      </div>
    </div>
  );
}

export default ContractorFilter;
